module.exports = "//static.hsappstatic.net/pricing-pages-ui/static-1.22465/js/img/productIcons/ServiceHub_Ent.svg"